var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivitySummaryIconThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H3.16667V4.7H15.8333V0.5H19V9.6077C17.4206 8.86158 15.6264 8.69678 13.9363 9.14259C12.2463 9.5884 10.7699 10.6159 9.76972 12.0425C8.76953 13.4691 8.31031 15.2023 8.47372 16.9339C8.63712 18.6656 9.41256 20.2835 10.6622 21.5H0V0.5Z",
    fill: "#E8505B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitySummaryIconThree);
export default __webpack_public_path__ + "static/media/activity_summary_icon_three.322ccb4e6a6fb5aa8629c1523500c6f0.svg";
export { ForwardRef as ReactComponent };